var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediaIcon = function SvgMediaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.527 4.689a1.14 1.14 0 0 0-.975-.937 57.2 57.2 0 0 0-15.105 0 1.15 1.15 0 0 0-.975.937 30.1 30.1 0 0 0 0 10.62 1.15 1.15 0 0 0 .975.938 57 57 0 0 0 7.553.502c2.526.002 5.05-.166 7.552-.502a1.14 1.14 0 0 0 .976-.938c.63-3.512.63-7.108 0-10.62zM7 12.25v-4.5a.75.75 0 0 1 1.147-.645l4.448 2.25a.75.75 0 0 1 0 1.29l-4.448 2.25A.75.75 0 0 1 7 12.25"
  })));
};
export { SvgMediaIcon as ReactComponent };